/*
 * This file is a generated Typescript file for GRPC Gateway, DO NOT MODIFY
 */

import * as fm from "../../../fm"


/**
 * Сервис реализует функционал управления привилегиями.
 * Привилегии это услуги на квартиру со статусами, в их число входят привилегии которые можно подключить, но ещё не приобретены
 */

/**
 * Сервис привилегий
 */
export class PrivilegeServiceClient {
  /**
   * Конструктор сервиса
   * @param host Адрес хоста
   * @param token Токен доступа
   */
  constructor(
    public host = "",
    public token = ""
  ) { }

  /**
   * Метод получения привилегий.
   * Метод доступен для: admin, master, service, ltp_first, application(subscription:read или subscription:edit)
   */
  GetPrivilegeList = (req?: GetPrivilegeListRequestDto, init?: RequestInit): Promise<GetPrivilegeListResponseDto[]> => {
    return fm.list<GetPrivilegeListRequestDto, GetPrivilegeListResponseDto>(`${this.host}/subscription/api/v1/privilege/list${fm.buildQuery(req)}`, {...init, method: "GET", ...{ headers: { ...init?.headers, ...{ 'Authorization': `Bearer ${this.token}` } } } })
  }
  /**
   * Метод получения количества привилегий.
   * Метод доступен для: admin, master, service, ltp_first, application(subscription:read или subscription:edit)
   */
  GetPrivilegeCount = (req?: GetPrivilegeCountRequestDto, init?: RequestInit): Promise<GetPrivilegeCountResponseDto> => {
    return fm.request<GetPrivilegeCountRequestDto, GetPrivilegeCountResponseDto>(`${this.host}/subscription/api/v1/privilege/count${fm.buildQuery(req)}`, { ...init, method: "GET", ...{ headers: { ...init?.headers, ...{ 'Authorization': `Bearer ${this.token}` } } } })
  }

  /**
   * Метод проверки привилегии.
   * Метод доступен для: admin, master, service, ltp_first, application(subscription:read или subscription:edit)
   */
  GetPrivilegeCheck = (req: GetPrivilegeCheckRequestDto, init?: RequestInit): Promise<GetPrivilegeCheckResponseDto> => {
    return fm.request<GetPrivilegeCheckRequestDto, GetPrivilegeCheckResponseDto>(`${this.host}/subscription/api/v1/privilege/check/${encodeURIComponent(req.orpon)}/${encodeURIComponent(req.flatNumber)}/${encodeURIComponent(req.privilegeType)}${fm.buildQuery(req, ["orpon","flatNumber","privilegeType"])}`, { ...init, method: "GET", ...{ headers: { ...init?.headers, ...{ 'Authorization': `Bearer ${this.token}` } } } })
  }

}

/**
 * Типы состояний привилегий
 */
export enum PrivilegeStateType {
  /**
   * Значение не указано
   */
  STATE_TYPE_UNKNOWN = "STATE_TYPE_UNKNOWN",
  /**
   * Услуга доступная для подключения на доме пользователя, но не активна.
   * Услуга есть в доступных КВ на ОРПОН, но её нет у пользователя
   */
  CAN_BE_PAID = "CAN_BE_PAID",
  /**
   * Услуга не оплачена и не активна.
   * Услуга есть в подписке в статусе: BLOCKED
   */
  NOT_PAID = "NOT_PAID",
  /**
   * Услуга отключается, но ещё активна.
   * Услуга есть в подписке в статусе: SCHEDULED_CANCELED
   */
  TURNS_OFF = "TURNS_OFF",
  /**
   * Услуга в промо-периоде и активна.
   * Услуга есть в подписке в статусе: SETUP.
   * Обычно так создают промоподписки
   */
  PROMO = "PROMO",
  /**
   * Услуга оплачена и активна.
   * Услуга есть в подписке в статусе: ACTIVE.
   * Либо услуга есть в подписке с неблокируемой услугой
   */
  PAID = "PAID",
}
/**
 * Типы состояний привилегий
 */
export type PrivilegeStateTypeResponseEnum = keyof typeof PrivilegeStateType
/**
 * Типы состояний привилегий
 */
export type PrivilegeStateTypeRequestEnum = Exclude<PrivilegeStateTypeResponseEnum, "STATE_TYPE_UNKNOWN">;

/**
 * Типы привилегий
 */
export enum PrivilegeType {
  /**
   * Значение не указано
   */
  TYPE_UNKNOWN = "TYPE_UNKNOWN",
  /**
   * Умный домофон.
   * Базовые функции.
   * Право доступа к разделу с домофонами и калиткаи.
   * Действие.
   * Закрывает услуги: get_devices_intercom
   */
  INTERCOM_USE = "INTERCOM_USE",
  /**
   * Умный домофон.
   * Базовые функции.
   * Право использовать функционал открытия двери домофона и калитки.
   * Действие.
   * Закрывает услуги: post_devices_open_intercom
   */
  INTERCOM_OPEN = "INTERCOM_OPEN",
  /**
   * Умный домофон.
   * Коды.
   * Право использовать функционал кодов домофонов и калиток.
   * Действие.
   * Закрывает услуги: get_devices_codes_intercom, post_devices_codes_intercom, delete_devices_codes_intercom
   */
  INTERCOM_CODE_USE = "INTERCOM_CODE_USE",
  /**
   * Умный домофон.
   * Ключи.
   * Право использовать функционал физических ключей домофонов и калиток.
   * Действие.
   * Закрывает услуги: get_devices_rfids_intercom, post_devices_rfids_barrier, delete_devices_rfids_barrier
   */
  INTERCOM_RFID_USE = "INTERCOM_RFID_USE",
  /**
   * Умный домофон.
   * События.
   * Право использовать функционал журнала событий домофонов и калиток.
   * Действие.
   * Закрывает услуги: get_events_intercom
   */
  INTERCOM_EVENT_USE = "INTERCOM_EVENT_USE",
  /**
   * Умный домофон.
   * Камеры.
   * Право использовать функционал просмотра камер и лайв видео с домофонов и калиток.
   * Действие.
   * Закрывает услуги: get_devices_camera_intercom
   */
  INTERCOM_CAMERA_USE = "INTERCOM_CAMERA_USE",
  /**
   * Умный домофон.
   * Камеры.
   * Право использовать функционал архива видео с камер домофонов и калиток.
   * Действие.
   * Закрывает услуги: get_video_archive_intercom
   */
  INTERCOM_CAMERA_ARCHIVE = "INTERCOM_CAMERA_ARCHIVE",
  /**
   * Умный домофон.
   * Переадресация.
   * Право перенаправления входящих вызова от домофона в приложения, используется только на сервере.
   * Поведение.
   * Закрывает услуги: devices_call_redirect_to_mobile_app_behavior
   */
  INTERCOM_CALLREDIRECT_APP = "INTERCOM_CALLREDIRECT_APP",
  /**
   * Умный домофон.
   * Переадресация.
   * Право перенаправление входящих вызовов от домофона на номера ТФОП, используется только на сервере.
   * Поведение.
   * Закрывает услуги: devices_call_redirect_to_pstn_behavior
   */
  INTERCOM_CALLREDIRECT_PSTN = "INTERCOM_CALLREDIRECT_PSTN",
  /**
   * Умный домофон.
   * Переадресация.
   * Право перенаправление входящих вызовов от домофона на номера SIP, используется только на сервере.
   * Поведение.
   * Закрывает услуги: devices_call_redirect_to_sip_behavior
   */
  INTERCOM_CALLREDIRECT_SIP = "INTERCOM_CALLREDIRECT_SIP",
  /**
   * Умный шлагбаум.
   * Базовые функции.
   * Право доступа к разделу шлагбаумов.
   * Действие.
   * Закрывает услуги: get_devices_barrier
   */
  BARRIER_USE = "BARRIER_USE",
  /**
   * Умный шлагбаум.
   * Базовые функции.
   * Право использовать функционала поднятия стрелы шлагбаума.
   * Действие.
   * Закрывает услуги: post_devices_open_barrier
   */
  BARRIER_OPEN = "BARRIER_OPEN",
  /**
   * Умный шлагбаум.
   * Коды.
   * Право использовать функционал открытия шлагбаума по звонку на короткий номер.
   * Действие.
   * Закрывает услуги: get_devices_codes_barrier, post_devices_codes_barrier, delete_devices_codes_barrier
   */
  BARRIER_CODE_USE = "BARRIER_CODE_USE",
  /**
   * Умный шлагбаум.
   * События.
   * Право использовать функционал журнала событий шлагбаума.
   * Действие.
   * Закрывает услуги: get_events_barrier
   */
  BARRIER_EVENT_USE = "BARRIER_EVENT_USE",
  /**
   * Умный шлагбаум.
   * Камеры.
   * Право использовать функционал просмотра камер и лайв видео с шлагбаумов.
   * Действие.
   * Закрывает услуги: get_devices_camera_barrier
   */
  BARRIER_CAMERA_USE = "BARRIER_CAMERA_USE",
  /**
   * Умный шлагбаум.
   * Камеры.
   * Право использовать функционал архива видео с камер, направленных на шлагбаум.
   * Действие.
   * Закрывает услуги: get_video_archive_barrier
   */
  BARRIER_CAMERA_ARCHIVE = "BARRIER_CAMERA_ARCHIVE",
  /**
   * Распознавание лица.
   * Фото.
   * Право доступа к разделу распознавания лиц.
   * Действие.
   * Закрывает услуги: get_photo_fr_intercom, fr_intercom_access_behavior, post_photo_fr_intercom, delete_photo_fr_intercom
   */
  FR_USE = "FR_USE",
  /**
   * Телеметрия.
   * Базовые функции.
   * Право доступа к разделу показаний приборов учёта.
   * Действие.
   * Закрывает услуги: get_telemetry_rooms_layout
   */
  TELEMETRY_USE = "TELEMETRY_USE",
  /**
   * Камеры.
   * Базовые функции.
   * Право доступа к разделу камер и лайв видео с них.
   * Действие.
   * Закрывает услуги: get_devices_camera, get_events_camera, get_devices_camera_access_control_panel, get_devices_camera_barrier, get_devices_camera_intercom
   */
  CAMERA_USE = "CAMERA_USE",
  /**
   * Камеры.
   * Базовые функции.
   * Право использовать функционал архива видео с камер видеонаблюдения.
   * Действие.
   * Закрывает услуги: get_video_archive, get_video_archive_access_control_panel
   */
  CAMERA_ARCHIVE = "CAMERA_ARCHIVE",
  /**
   * Умный домофон.
   * Переадресация.
   * Право приёма входящих вызовов от домофона на аналоговую трубку, используется только на сервере.
   * Поведение.
   * Закрывает услуги: devices_call_to_cms_phones_behavior
   */
  INTERCOM_CMS_PHONES_USE = "INTERCOM_CMS_PHONES_USE",
  /**
   * Умный домофон.
   * Переадресация.
   * Право приёма входящих вызовов от домофона на аналоговую трубку, используется только на сервере.
   * Поведение.
   * Закрывает услуги: get_events_camera
   */
  CAMERA_EVENT_USE = "CAMERA_EVENT_USE",
}
/**
 * Типы привилегий
 */
export type PrivilegeTypeResponseEnum = keyof typeof PrivilegeType
/**
 * Типы привилегий
 */
export type PrivilegeTypeRequestEnum = Exclude<PrivilegeTypeResponseEnum, "TYPE_UNKNOWN">;

/**
 * Справочник типов направлений сортировки
 */
export enum PrivilegePagingDirectionType {
  /**
   * Значение не указано
   */
  DIRECTION_TYPE_UNKNOWN = "DIRECTION_TYPE_UNKNOWN",
  /**
   * От большего к меньшему
   */
  DESC = "DESC",
  /**
   * От меньшего к большему
   */
  ASC = "ASC",
}
/**
 * Справочник типов направлений сортировки
 */
export type PrivilegePagingDirectionTypeResponseEnum = keyof typeof PrivilegePagingDirectionType
/**
 * Справочник типов направлений сортировки
 */
export type PrivilegePagingDirectionTypeRequestEnum = Exclude<PrivilegePagingDirectionTypeResponseEnum, "DIRECTION_TYPE_UNKNOWN">;

/**
 * Справочник типов значений сортировки
 */
export enum PrivilegePagingOrderByType {
  /**
   * Значение не указано
   */
  ORDER_BY_TYPE_UNKNOWN = "ORDER_BY_TYPE_UNKNOWN",
  /**
   * По уникальному ключу: orpon+flat_number+type
   */
  KEY = "KEY",
}
/**
 * Справочник типов значений сортировки
 */
export type PrivilegePagingOrderByTypeResponseEnum = keyof typeof PrivilegePagingOrderByType
/**
 * Справочник типов значений сортировки
 */
export type PrivilegePagingOrderByTypeRequestEnum = Exclude<PrivilegePagingOrderByTypeResponseEnum, "ORDER_BY_TYPE_UNKNOWN">;

/**
 * Запрос проверки предоставленной привилегии
 */
export type GetPrivilegeCheckRequestDto = {
  /**
   * ОРПОН.
   * Идентификатор дома
   */
  orpon: string
  /**
   * Номер квартиры
   */
  flatNumber: string
  /**
   * Тип привилегии
   */
  privilegeType: PrivilegeTypeRequestEnum
}
/**
 * Результат запроса метода проверки предоставленной привилегии
 */
export type GetPrivilegeCheckResponseDto = {
}
/**
 * type
 */
& fm.OneOf<{
  /**
   * Доступна ли привилегия на квартире.
   * Вернётся true если статусы:
   * - PROMO;
   * - PAID;
   * - TURNS_OFF.
   * Вернётся false если статусы:
   * - NOT_PAID;
   * - CAN_BE_PAID;
   * - STATE_TYPE_UNKNOWN;
   * - Не найден
   */
  readonly data: boolean
}>
/**
 * Запрос получения количества привилегий
 */
export type GetPrivilegeCountRequestDto = {
  /**
   * Фильтр
   */
  filter?: PrivilegeFilterRequestDto | null
}
/**
 * Ответ на запрос получения количества привилегий
 */
export type GetPrivilegeCountResponseDto = {
}
/**
 * type
 */
& fm.OneOf<{
  /**
   * Всего привилегий
   */
  readonly data: number
  /**
   * Ошибка
   */
  readonly error: GetPrivilegeCountResponseErrorDto
}>
/**
 * Ошибка запроса получения количества привилегий
 */
export type GetPrivilegeCountResponseErrorRequestDto = {
}
/**
 * reason
 */
& fm.OptionalOneOf<{
  /**
   * Ошибка фильтрации по страницам по привилегиям
   */
  readonly privilegeFilterValidation: PrivilegeFilterValidationErrorRequestDto
}>
/**
 * Ошибка запроса получения количества привилегий
 */
export type GetPrivilegeCountResponseErrorDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка фильтрации по страницам по привилегиям
   */
  readonly privilegeFilterValidation: PrivilegeFilterValidationErrorResponseDto
}>
/**
 * Запрос получения привилегий
 */
export type GetPrivilegeListRequestDto = {
  /**
   * Фильтр
   */
  filter?: PrivilegeFilterRequestDto | null
}
/**
 * pagination
 */
& fm.OptionalOneOf<{
  /**
   * Пагинация
   */
  readonly paging: PrivilegePagingRequestDto
}>
/**
 * Ответ на запрос получения привилегий
 */
export type GetPrivilegeListResponseDto = {
}
/**
 * type
 */
& fm.OneOf<{
  /**
   * Предоставленная привилегия
   */
  readonly data: PrivilegeResponseDto
  /**
   * Ошибка
   */
  readonly error: GetPrivilegeListResponseErrorDto
}>
/**
 * Ошибка запроса получения привилегий
 */
export type GetPrivilegeListResponseErrorRequestDto = {
}
/**
 * reason
 */
& fm.OptionalOneOf<{
  /**
   * Ошибка фильтрации по страницам
   */
  readonly privilegeFilterValidation: PrivilegeFilterValidationErrorRequestDto
  /**
   * Ошибка пагинации по страницам
   */
  readonly privilegePagingValidation: PrivilegePagingValidationErrorRequestDto
}>
/**
 * Ошибка запроса получения привилегий
 */
export type GetPrivilegeListResponseErrorDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка фильтрации по страницам
   */
  readonly privilegeFilterValidation: PrivilegeFilterValidationErrorResponseDto
  /**
   * Ошибка пагинации по страницам
   */
  readonly privilegePagingValidation: PrivilegePagingValidationErrorResponseDto
}>
/**
 * Привилегия
 */
export type PrivilegeRequestDto = {
  /**
   * ОРПОН.
   * Идентификатор дома.
   * Уникальный ключ: поля в порядке 1,2,3
   */
  orpon: string
  /**
   * Номер квартиры
   */
  flatNumber: string
  /**
   * Тип привилегии
   */
  type: PrivilegeTypeRequestEnum
  /**
   * Состояние привилегии
   */
  stateType: PrivilegeStateTypeRequestEnum
}
/**
 * Привилегия
 */
export type PrivilegeResponseDto = {
  /**
   * ОРПОН.
   * Идентификатор дома.
   * Уникальный ключ: поля в порядке 1,2,3
   */
  orpon: string
  /**
   * Номер квартиры
   */
  flatNumber: string
  /**
   * Тип привилегии
   */
  type: PrivilegeTypeResponseEnum
  /**
   * Состояние привилегии
   */
  stateType: PrivilegeStateTypeResponseEnum
}
/**
 * Фильтр по привилегиям
 */
export type PrivilegeFilterRequestDto = {
  /**
   * По ОРПОНам
   */
  orpons?: string[]
  /**
   * Номера квартир
   */
  flatNumbers?: string[]
  /**
   * По типам привилегий
   */
  types?: PrivilegeTypeResponseEnum[]
  /**
   * По состояниям привилегий
   */
  stateTypes?: PrivilegeStateTypeResponseEnum[]
}
/**
 * Фильтр по привилегиям
 */
export type PrivilegeFilterResponseDto = {
  /**
   * По ОРПОНам
   */
  orpons: string[]
  /**
   * Номера квартир
   */
  flatNumbers: string[]
  /**
   * По типам привилегий
   */
  types: PrivilegeTypeResponseEnum[]
  /**
   * По состояниям привилегий
   */
  stateTypes: PrivilegeStateTypeResponseEnum[]
}
/**
 * Ошибка валидации фильтра по привилегиям.
 * Эти проверки выполняются до обращения в базу данных
 */
export type PrivilegeFilterValidationErrorRequestDto = {
}
/**
 * reason
 */
& fm.OptionalOneOf<{
  /**
   * Формат ОРПОН некорректен
   */
  readonly orpons: PrivilegeFilterValidationErrorOrponsInvalidRequestDto
  /**
   * Формат квартиры некорректен
   */
  readonly flatNumbers: PrivilegeFilterValidationErrorFlatNumbersInvalidRequestDto
}>
/**
 * Ошибка валидации фильтра по привилегиям.
 * Эти проверки выполняются до обращения в базу данных
 */
export type PrivilegeFilterValidationErrorResponseDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Формат ОРПОН некорректен
   */
  readonly orpons: PrivilegeFilterValidationErrorOrponsInvalidResponseDto
  /**
   * Формат квартиры некорректен
   */
  readonly flatNumbers: PrivilegeFilterValidationErrorFlatNumbersInvalidResponseDto
}>
/**
 * Причины:
 * - Формат квартиры некорректен (например, длина номера квартира более 4 знаков);
 * - Номер квартиры содержит буквы
 */
export type PrivilegeFilterValidationErrorFlatNumbersInvalidRequestDto = {
}
/**
 * Причины:
 * - Формат квартиры некорректен (например, длина номера квартира более 4 знаков);
 * - Номер квартиры содержит буквы
 */
export type PrivilegeFilterValidationErrorFlatNumbersInvalidResponseDto = {
}
/**
 * Причины:
 * - Формат ОРПОН некорректен;
 * - Передано отрицательное значение
 */
export type PrivilegeFilterValidationErrorOrponsInvalidRequestDto = {
}
/**
 * Причины:
 * - Формат ОРПОН некорректен;
 * - Передано отрицательное значение
 */
export type PrivilegeFilterValidationErrorOrponsInvalidResponseDto = {
}
/**
 * Пагинация по привилегиям
 */
export type PrivilegePagingRequestDto = {
  /**
   * Тип значения сортировки.
   * По умолчанию: KEY
   */
  orderByType?: PrivilegePagingOrderByTypeRequestEnum | "ORDER_BY_TYPE_UNKNOWN"
  /**
   * Тип направления сортировки.
   * По умолчанию: DESC
   */
  directionType?: PrivilegePagingDirectionTypeRequestEnum | "DIRECTION_TYPE_UNKNOWN"
  /**
   * Количество записей на страницу.
   * Минимальное значение: 1.
   * Максимальное значение: 100.
   * По умолчанию: 20.
   * Если значение 0 (не передано), то выставляем значение по умолчанию
   */
  limit?: number
  /**
   * Сдвиг.
   * По умолчанию: 0
   */
  offset?: number
}
/**
 * Пагинация по привилегиям
 */
export type PrivilegePagingResponseDto = {
  /**
   * Тип значения сортировки.
   * По умолчанию: KEY
   */
  orderByType: PrivilegePagingOrderByTypeResponseEnum
  /**
   * Тип направления сортировки.
   * По умолчанию: DESC
   */
  directionType: PrivilegePagingDirectionTypeResponseEnum
  /**
   * Количество записей на страницу.
   * Минимальное значение: 1.
   * Максимальное значение: 100.
   * По умолчанию: 20.
   * Если значение 0 (не передано), то выставляем значение по умолчанию
   */
  limit: number
  /**
   * Сдвиг.
   * По умолчанию: 0
   */
  offset: number
}
/**
 * Ошибка валидации постраничной пагинации по привилегиям.
 * Эти проверки выполняются до обращения в базу данных
 */
export type PrivilegePagingValidationErrorRequestDto = {
}
/**
 * reason
 */
& fm.OptionalOneOf<{
  /**
   * Количество передано некорректно
   */
  readonly limit: PrivilegePagingValidationErrorLimitInvalidRequestDto
  /**
   * Сдвиг передан некорректно
   */
  readonly offset: PrivilegePagingValidationErrorOffsetInvalidRequestDto
}>
/**
 * Ошибка валидации постраничной пагинации по привилегиям.
 * Эти проверки выполняются до обращения в базу данных
 */
export type PrivilegePagingValidationErrorResponseDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Количество передано некорректно
   */
  readonly limit: PrivilegePagingValidationErrorLimitInvalidResponseDto
  /**
   * Сдвиг передан некорректно
   */
  readonly offset: PrivilegePagingValidationErrorOffsetInvalidResponseDto
}>
/**
 * Причины:
 * - Значение количества < 0 или > 100
 */
export type PrivilegePagingValidationErrorLimitInvalidRequestDto = {
}
/**
 * Причины:
 * - Значение количества < 0 или > 100
 */
export type PrivilegePagingValidationErrorLimitInvalidResponseDto = {
}
/**
 * Причины:
 * - Значение сдвига < 0
 */
export type PrivilegePagingValidationErrorOffsetInvalidRequestDto = {
}
/**
 * Причины:
 * - Значение сдвига < 0
 */
export type PrivilegePagingValidationErrorOffsetInvalidResponseDto = {
}
/**
 * Дескриптор
 */
export const descriptor = {
  /**
   * Запрос проверки предоставленной привилегии
   */
  "GetPrivilegeCheckRequest": {
    "kind": "class",
    "text": "Запрос проверки предоставленной привилегии",
    "fields": {
      /**
       * ОРПОН.
       * Идентификатор дома
       */
      "orpon": {
        "type": "int64",
        "text": "ОРПОН.\nИдентификатор дома",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Номер квартиры
       */
      "flatNumber": {
        "type": "string",
        "text": "Номер квартиры",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Тип привилегии
       */
      "privilegeType": {
        "type": "Privilege.Type",
        "text": "Тип привилегии",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
    },
  },
  /**
   * Результат запроса метода проверки предоставленной привилегии
   */
  "GetPrivilegeCheckResponse": {
    "kind": "class",
    "text": "Результат запроса метода проверки предоставленной привилегии",
    "fields": {
      /**
       * Доступна ли привилегия на квартире.
       * Вернётся true если статусы:
       * - PROMO;
       * - PAID;
       * - TURNS_OFF.
       * Вернётся false если статусы:
       * - NOT_PAID;
       * - CAN_BE_PAID;
       * - STATE_TYPE_UNKNOWN;
       * - Не найден
       */
      "data": {
        "type": "bool",
        "text": "Доступна ли привилегия на квартире.\nВернётся true если статусы:\n- PROMO;\n- PAID;\n- TURNS_OFF.\nВернётся false если статусы:\n- NOT_PAID;\n- CAN_BE_PAID;\n- STATE_TYPE_UNKNOWN;\n- Не найден",
      },
    },
  },
  /**
   * Запрос получения количества привилегий
   */
  "GetPrivilegeCountRequest": {
    "kind": "class",
    "text": "Запрос получения количества привилегий",
    "fields": {
      /**
       * Фильтр
       */
      "filter": {
        "type": "PrivilegeFilter",
        "text": "Фильтр",
      },
    },
  },
  /**
   * Ответ на запрос получения количества привилегий
   */
  "GetPrivilegeCountResponse": {
    "kind": "class",
    "text": "Ответ на запрос получения количества привилегий",
    "fields": {
      /**
       * Всего привилегий
       */
      "data": {
        "type": "int32",
        "text": "Всего привилегий",
      },
      /**
       * Ошибка
       */
      "error": {
        "type": "GetPrivilegeCountResponse.Error",
        "text": "Ошибка",
      },
    },
  },
  /**
   * Ошибка запроса получения количества привилегий
   */
  "GetPrivilegeCountResponse.Error": {
    "kind": "class",
    "text": "Ошибка запроса получения количества привилегий",
    "fields": {
      /**
       * Ошибка фильтрации по страницам по привилегиям
       */
      "privilegeFilterValidation": {
        "type": "PrivilegeFilter.ValidationError",
        "text": "Ошибка фильтрации по страницам по привилегиям",
      },
    },
  },
  /**
   * Запрос получения привилегий
   */
  "GetPrivilegeListRequest": {
    "kind": "class",
    "text": "Запрос получения привилегий",
    "fields": {
      /**
       * Фильтр
       */
      "filter": {
        "type": "PrivilegeFilter",
        "text": "Фильтр",
      },
      /**
       * Пагинация
       */
      "paging": {
        "type": "PrivilegePaging",
        "text": "Пагинация",
      },
    },
  },
  /**
   * Ответ на запрос получения привилегий
   */
  "GetPrivilegeListResponse": {
    "kind": "class",
    "text": "Ответ на запрос получения привилегий",
    "fields": {
      /**
       * Предоставленная привилегия
       */
      "data": {
        "type": "Privilege",
        "text": "Предоставленная привилегия",
      },
      /**
       * Ошибка
       */
      "error": {
        "type": "GetPrivilegeListResponse.Error",
        "text": "Ошибка",
      },
    },
  },
  /**
   * Ошибка запроса получения привилегий
   */
  "GetPrivilegeListResponse.Error": {
    "kind": "class",
    "text": "Ошибка запроса получения привилегий",
    "fields": {
      /**
       * Ошибка фильтрации по страницам
       */
      "privilegeFilterValidation": {
        "type": "PrivilegeFilter.ValidationError",
        "text": "Ошибка фильтрации по страницам",
      },
      /**
       * Ошибка пагинации по страницам
       */
      "privilegePagingValidation": {
        "type": "PrivilegePaging.ValidationError",
        "text": "Ошибка пагинации по страницам",
      },
    },
  },
  /**
   * Привилегия
   */
  "Privilege": {
    "kind": "class",
    "text": "Привилегия",
    "fields": {
      /**
       * ОРПОН.
       * Идентификатор дома.
       * Уникальный ключ: поля в порядке 1,2,3
       */
      "orpon": {
        "type": "int64",
        "text": "ОРПОН.\nИдентификатор дома.\nУникальный ключ: поля в порядке 1,2,3",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Номер квартиры
       */
      "flatNumber": {
        "type": "string",
        "text": "Номер квартиры",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Тип привилегии
       */
      "type": {
        "type": "Privilege.Type",
        "text": "Тип привилегии",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Состояние привилегии
       */
      "stateType": {
        "type": "Privilege.StateType",
        "text": "Состояние привилегии",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
    },
  },
  /**
   * Фильтр по привилегиям
   */
  "PrivilegeFilter": {
    "kind": "class",
    "text": "Фильтр по привилегиям",
    "fields": {
      /**
       * По ОРПОНам
       */
      "orpons": {
        "type": "int64",
        "text": "По ОРПОНам",
      },
      /**
       * Номера квартир
       */
      "flatNumbers": {
        "type": "string",
        "text": "Номера квартир",
      },
      /**
       * По типам привилегий
       */
      "types": {
        "type": "Privilege.Type",
        "text": "По типам привилегий",
      },
      /**
       * По состояниям привилегий
       */
      "stateTypes": {
        "type": "Privilege.StateType",
        "text": "По состояниям привилегий",
      },
    },
  },
  /**
   * Ошибка валидации фильтра по привилегиям.
   * Эти проверки выполняются до обращения в базу данных
   */
  "PrivilegeFilter.ValidationError": {
    "kind": "class",
    "text": "Ошибка валидации фильтра по привилегиям.\nЭти проверки выполняются до обращения в базу данных",
    "fields": {
      /**
       * Формат ОРПОН некорректен
       */
      "orpons": {
        "type": "PrivilegeFilter.ValidationError.OrponsInvalid",
        "text": "Формат ОРПОН некорректен",
      },
      /**
       * Формат квартиры некорректен
       */
      "flatNumbers": {
        "type": "PrivilegeFilter.ValidationError.FlatNumbersInvalid",
        "text": "Формат квартиры некорректен",
      },
    },
  },
  /**
   * Причины:
   * - Формат квартиры некорректен (например, длина номера квартира более 4 знаков);
   * - Номер квартиры содержит буквы
   */
  "PrivilegeFilter.ValidationError.FlatNumbersInvalid": {
    "kind": "class",
    "text": "Причины:\n- Формат квартиры некорректен (например, длина номера квартира более 4 знаков);\n- Номер квартиры содержит буквы",
  },
  /**
   * Причины:
   * - Формат ОРПОН некорректен;
   * - Передано отрицательное значение
   */
  "PrivilegeFilter.ValidationError.OrponsInvalid": {
    "kind": "class",
    "text": "Причины:\n- Формат ОРПОН некорректен;\n- Передано отрицательное значение",
  },
  /**
   * Пагинация по привилегиям
   */
  "PrivilegePaging": {
    "kind": "class",
    "text": "Пагинация по привилегиям",
    "fields": {
      /**
       * Тип значения сортировки.
       * По умолчанию: KEY
       */
      "orderByType": {
        "type": "PrivilegePaging.OrderByType",
        "text": "Тип значения сортировки.\nПо умолчанию: KEY",
      },
      /**
       * Тип направления сортировки.
       * По умолчанию: DESC
       */
      "directionType": {
        "type": "PrivilegePaging.DirectionType",
        "text": "Тип направления сортировки.\nПо умолчанию: DESC",
      },
      /**
       * Количество записей на страницу.
       * Минимальное значение: 1.
       * Максимальное значение: 100.
       * По умолчанию: 20.
       * Если значение 0 (не передано), то выставляем значение по умолчанию
       */
      "limit": {
        "type": "int32",
        "text": "Количество записей на страницу.\nМинимальное значение: 1.\nМаксимальное значение: 100.\nПо умолчанию: 20.\nЕсли значение 0 (не передано), то выставляем значение по умолчанию",
      },
      /**
       * Сдвиг.
       * По умолчанию: 0
       */
      "offset": {
        "type": "int32",
        "text": "Сдвиг.\nПо умолчанию: 0",
      },
    },
  },
  /**
   * Ошибка валидации постраничной пагинации по привилегиям.
   * Эти проверки выполняются до обращения в базу данных
   */
  "PrivilegePaging.ValidationError": {
    "kind": "class",
    "text": "Ошибка валидации постраничной пагинации по привилегиям.\nЭти проверки выполняются до обращения в базу данных",
    "fields": {
      /**
       * Количество передано некорректно
       */
      "limit": {
        "type": "PrivilegePaging.ValidationError.LimitInvalid",
        "text": "Количество передано некорректно",
      },
      /**
       * Сдвиг передан некорректно
       */
      "offset": {
        "type": "PrivilegePaging.ValidationError.OffsetInvalid",
        "text": "Сдвиг передан некорректно",
      },
    },
  },
  /**
   * Причины:
   * - Значение количества < 0 или > 100
   */
  "PrivilegePaging.ValidationError.LimitInvalid": {
    "kind": "class",
    "text": "Причины:\n- Значение количества < 0 или > 100",
  },
  /**
   * Причины:
   * - Значение сдвига < 0
   */
  "PrivilegePaging.ValidationError.OffsetInvalid": {
    "kind": "class",
    "text": "Причины:\n- Значение сдвига < 0",
  },
  /**
   * Типы состояний привилегий
   */
  "Privilege.StateType": {
    "kind": "enum",
    "text": "Типы состояний привилегий",
    "values": {
      /**
       * Значение не указано
       */
      "STATE_TYPE_UNKNOWN": {
        "i": 0,
        "text": "Значение не указано",
      },
      /**
       * Услуга доступная для подключения на доме пользователя, но не активна.
       * Услуга есть в доступных КВ на ОРПОН, но её нет у пользователя
       */
      "CAN_BE_PAID": {
        "i": 1,
        "text": "Услуга доступная для подключения на доме пользователя, но не активна.\nУслуга есть в доступных КВ на ОРПОН, но её нет у пользователя",
      },
      /**
       * Услуга не оплачена и не активна.
       * Услуга есть в подписке в статусе: BLOCKED
       */
      "NOT_PAID": {
        "i": 2,
        "text": "Услуга не оплачена и не активна.\nУслуга есть в подписке в статусе: BLOCKED",
      },
      /**
       * Услуга отключается, но ещё активна.
       * Услуга есть в подписке в статусе: SCHEDULED_CANCELED
       */
      "TURNS_OFF": {
        "i": 3,
        "text": "Услуга отключается, но ещё активна.\nУслуга есть в подписке в статусе: SCHEDULED_CANCELED",
      },
      /**
       * Услуга в промо-периоде и активна.
       * Услуга есть в подписке в статусе: SETUP.
       * Обычно так создают промоподписки
       */
      "PROMO": {
        "i": 4,
        "text": "Услуга в промо-периоде и активна.\nУслуга есть в подписке в статусе: SETUP.\nОбычно так создают промоподписки",
      },
      /**
       * Услуга оплачена и активна.
       * Услуга есть в подписке в статусе: ACTIVE.
       * Либо услуга есть в подписке с неблокируемой услугой
       */
      "PAID": {
        "i": 5,
        "text": "Услуга оплачена и активна.\nУслуга есть в подписке в статусе: ACTIVE.\nЛибо услуга есть в подписке с неблокируемой услугой",
      },
    },
  },
  /**
   * Типы привилегий
   */
  "Privilege.Type": {
    "kind": "enum",
    "text": "Типы привилегий",
    "values": {
      /**
       * Значение не указано
       */
      "TYPE_UNKNOWN": {
        "i": 0,
        "text": "Значение не указано",
      },
      /**
       * Умный домофон.
       * Базовые функции.
       * Право доступа к разделу с домофонами и калиткаи.
       * Действие.
       * Закрывает услуги: get_devices_intercom
       */
      "INTERCOM_USE": {
        "i": 1,
        "text": "Умный домофон.\nБазовые функции.\nПраво доступа к разделу с домофонами и калиткаи.\nДействие.\nЗакрывает услуги: get_devices_intercom",
      },
      /**
       * Умный домофон.
       * Базовые функции.
       * Право использовать функционал открытия двери домофона и калитки.
       * Действие.
       * Закрывает услуги: post_devices_open_intercom
       */
      "INTERCOM_OPEN": {
        "i": 2,
        "text": "Умный домофон.\nБазовые функции.\nПраво использовать функционал открытия двери домофона и калитки.\nДействие.\nЗакрывает услуги: post_devices_open_intercom",
      },
      /**
       * Умный домофон.
       * Коды.
       * Право использовать функционал кодов домофонов и калиток.
       * Действие.
       * Закрывает услуги: get_devices_codes_intercom, post_devices_codes_intercom, delete_devices_codes_intercom
       */
      "INTERCOM_CODE_USE": {
        "i": 3,
        "text": "Умный домофон.\nКоды.\nПраво использовать функционал кодов домофонов и калиток.\nДействие.\nЗакрывает услуги: get_devices_codes_intercom, post_devices_codes_intercom, delete_devices_codes_intercom",
      },
      /**
       * Умный домофон.
       * Ключи.
       * Право использовать функционал физических ключей домофонов и калиток.
       * Действие.
       * Закрывает услуги: get_devices_rfids_intercom, post_devices_rfids_barrier, delete_devices_rfids_barrier
       */
      "INTERCOM_RFID_USE": {
        "i": 4,
        "text": "Умный домофон.\nКлючи.\nПраво использовать функционал физических ключей домофонов и калиток.\nДействие.\nЗакрывает услуги: get_devices_rfids_intercom, post_devices_rfids_barrier, delete_devices_rfids_barrier",
      },
      /**
       * Умный домофон.
       * События.
       * Право использовать функционал журнала событий домофонов и калиток.
       * Действие.
       * Закрывает услуги: get_events_intercom
       */
      "INTERCOM_EVENT_USE": {
        "i": 5,
        "text": "Умный домофон.\nСобытия.\nПраво использовать функционал журнала событий домофонов и калиток.\nДействие.\nЗакрывает услуги: get_events_intercom",
      },
      /**
       * Умный домофон.
       * Камеры.
       * Право использовать функционал просмотра камер и лайв видео с домофонов и калиток.
       * Действие.
       * Закрывает услуги: get_devices_camera_intercom
       */
      "INTERCOM_CAMERA_USE": {
        "i": 6,
        "text": "Умный домофон.\nКамеры.\nПраво использовать функционал просмотра камер и лайв видео с домофонов и калиток.\nДействие.\nЗакрывает услуги: get_devices_camera_intercom",
      },
      /**
       * Умный домофон.
       * Камеры.
       * Право использовать функционал архива видео с камер домофонов и калиток.
       * Действие.
       * Закрывает услуги: get_video_archive_intercom
       */
      "INTERCOM_CAMERA_ARCHIVE": {
        "i": 7,
        "text": "Умный домофон.\nКамеры.\nПраво использовать функционал архива видео с камер домофонов и калиток.\nДействие.\nЗакрывает услуги: get_video_archive_intercom",
      },
      /**
       * Умный домофон.
       * Переадресация.
       * Право перенаправления входящих вызова от домофона в приложения, используется только на сервере.
       * Поведение.
       * Закрывает услуги: devices_call_redirect_to_mobile_app_behavior
       */
      "INTERCOM_CALLREDIRECT_APP": {
        "i": 8,
        "text": "Умный домофон.\nПереадресация.\nПраво перенаправления входящих вызова от домофона в приложения, используется только на сервере.\nПоведение.\nЗакрывает услуги: devices_call_redirect_to_mobile_app_behavior",
      },
      /**
       * Умный домофон.
       * Переадресация.
       * Право перенаправление входящих вызовов от домофона на номера ТФОП, используется только на сервере.
       * Поведение.
       * Закрывает услуги: devices_call_redirect_to_pstn_behavior
       */
      "INTERCOM_CALLREDIRECT_PSTN": {
        "i": 9,
        "text": "Умный домофон.\nПереадресация.\nПраво перенаправление входящих вызовов от домофона на номера ТФОП, используется только на сервере.\nПоведение.\nЗакрывает услуги: devices_call_redirect_to_pstn_behavior",
      },
      /**
       * Умный домофон.
       * Переадресация.
       * Право перенаправление входящих вызовов от домофона на номера SIP, используется только на сервере.
       * Поведение.
       * Закрывает услуги: devices_call_redirect_to_sip_behavior
       */
      "INTERCOM_CALLREDIRECT_SIP": {
        "i": 10,
        "text": "Умный домофон.\nПереадресация.\nПраво перенаправление входящих вызовов от домофона на номера SIP, используется только на сервере.\nПоведение.\nЗакрывает услуги: devices_call_redirect_to_sip_behavior",
      },
      /**
       * Умный шлагбаум.
       * Базовые функции.
       * Право доступа к разделу шлагбаумов.
       * Действие.
       * Закрывает услуги: get_devices_barrier
       */
      "BARRIER_USE": {
        "i": 11,
        "text": "Умный шлагбаум.\nБазовые функции.\nПраво доступа к разделу шлагбаумов.\nДействие.\nЗакрывает услуги: get_devices_barrier",
      },
      /**
       * Умный шлагбаум.
       * Базовые функции.
       * Право использовать функционала поднятия стрелы шлагбаума.
       * Действие.
       * Закрывает услуги: post_devices_open_barrier
       */
      "BARRIER_OPEN": {
        "i": 12,
        "text": "Умный шлагбаум.\nБазовые функции.\nПраво использовать функционала поднятия стрелы шлагбаума.\nДействие.\nЗакрывает услуги: post_devices_open_barrier",
      },
      /**
       * Умный шлагбаум.
       * Коды.
       * Право использовать функционал открытия шлагбаума по звонку на короткий номер.
       * Действие.
       * Закрывает услуги: get_devices_codes_barrier, post_devices_codes_barrier, delete_devices_codes_barrier
       */
      "BARRIER_CODE_USE": {
        "i": 13,
        "text": "Умный шлагбаум.\nКоды.\nПраво использовать функционал открытия шлагбаума по звонку на короткий номер.\nДействие.\nЗакрывает услуги: get_devices_codes_barrier, post_devices_codes_barrier, delete_devices_codes_barrier",
      },
      /**
       * Умный шлагбаум.
       * События.
       * Право использовать функционал журнала событий шлагбаума.
       * Действие.
       * Закрывает услуги: get_events_barrier
       */
      "BARRIER_EVENT_USE": {
        "i": 14,
        "text": "Умный шлагбаум.\nСобытия.\nПраво использовать функционал журнала событий шлагбаума.\nДействие.\nЗакрывает услуги: get_events_barrier",
      },
      /**
       * Умный шлагбаум.
       * Камеры.
       * Право использовать функционал просмотра камер и лайв видео с шлагбаумов.
       * Действие.
       * Закрывает услуги: get_devices_camera_barrier
       */
      "BARRIER_CAMERA_USE": {
        "i": 15,
        "text": "Умный шлагбаум.\nКамеры.\nПраво использовать функционал просмотра камер и лайв видео с шлагбаумов.\nДействие.\nЗакрывает услуги: get_devices_camera_barrier",
      },
      /**
       * Умный шлагбаум.
       * Камеры.
       * Право использовать функционал архива видео с камер, направленных на шлагбаум.
       * Действие.
       * Закрывает услуги: get_video_archive_barrier
       */
      "BARRIER_CAMERA_ARCHIVE": {
        "i": 16,
        "text": "Умный шлагбаум.\nКамеры.\nПраво использовать функционал архива видео с камер, направленных на шлагбаум.\nДействие.\nЗакрывает услуги: get_video_archive_barrier",
      },
      /**
       * Распознавание лица.
       * Фото.
       * Право доступа к разделу распознавания лиц.
       * Действие.
       * Закрывает услуги: get_photo_fr_intercom, fr_intercom_access_behavior, post_photo_fr_intercom, delete_photo_fr_intercom
       */
      "FR_USE": {
        "i": 17,
        "text": "Распознавание лица.\nФото.\nПраво доступа к разделу распознавания лиц.\nДействие.\nЗакрывает услуги: get_photo_fr_intercom, fr_intercom_access_behavior, post_photo_fr_intercom, delete_photo_fr_intercom",
      },
      /**
       * Телеметрия.
       * Базовые функции.
       * Право доступа к разделу показаний приборов учёта.
       * Действие.
       * Закрывает услуги: get_telemetry_rooms_layout
       */
      "TELEMETRY_USE": {
        "i": 18,
        "text": "Телеметрия.\nБазовые функции.\nПраво доступа к разделу показаний приборов учёта.\nДействие.\nЗакрывает услуги: get_telemetry_rooms_layout",
      },
      /**
       * Камеры.
       * Базовые функции.
       * Право доступа к разделу камер и лайв видео с них.
       * Действие.
       * Закрывает услуги: get_devices_camera, get_events_camera, get_devices_camera_access_control_panel, get_devices_camera_barrier, get_devices_camera_intercom
       */
      "CAMERA_USE": {
        "i": 19,
        "text": "Камеры.\nБазовые функции.\nПраво доступа к разделу камер и лайв видео с них.\nДействие.\nЗакрывает услуги: get_devices_camera, get_events_camera, get_devices_camera_access_control_panel, get_devices_camera_barrier, get_devices_camera_intercom",
      },
      /**
       * Камеры.
       * Базовые функции.
       * Право использовать функционал архива видео с камер видеонаблюдения.
       * Действие.
       * Закрывает услуги: get_video_archive, get_video_archive_access_control_panel
       */
      "CAMERA_ARCHIVE": {
        "i": 20,
        "text": "Камеры.\nБазовые функции.\nПраво использовать функционал архива видео с камер видеонаблюдения.\nДействие.\nЗакрывает услуги: get_video_archive, get_video_archive_access_control_panel",
      },
      /**
       * Умный домофон.
       * Переадресация.
       * Право приёма входящих вызовов от домофона на аналоговую трубку, используется только на сервере.
       * Поведение.
       * Закрывает услуги: devices_call_to_cms_phones_behavior
       */
      "INTERCOM_CMS_PHONES_USE": {
        "i": 21,
        "text": "Умный домофон.\nПереадресация.\nПраво приёма входящих вызовов от домофона на аналоговую трубку, используется только на сервере.\nПоведение.\nЗакрывает услуги: devices_call_to_cms_phones_behavior",
      },
      /**
       * Умный домофон.
       * Переадресация.
       * Право приёма входящих вызовов от домофона на аналоговую трубку, используется только на сервере.
       * Поведение.
       * Закрывает услуги: get_events_camera
       */
      "CAMERA_EVENT_USE": {
        "i": 22,
        "text": "Умный домофон.\nПереадресация.\nПраво приёма входящих вызовов от домофона на аналоговую трубку, используется только на сервере.\nПоведение.\nЗакрывает услуги: get_events_camera",
      },
    },
  },
  /**
   * Справочник типов направлений сортировки
   */
  "PrivilegePaging.DirectionType": {
    "kind": "enum",
    "text": "Справочник типов направлений сортировки",
    "values": {
      /**
       * Значение не указано
       */
      "DIRECTION_TYPE_UNKNOWN": {
        "i": 0,
        "text": "Значение не указано",
      },
      /**
       * От большего к меньшему
       */
      "DESC": {
        "i": 1,
        "text": "От большего к меньшему",
      },
      /**
       * От меньшего к большему
       */
      "ASC": {
        "i": 2,
        "text": "От меньшего к большему",
      },
    },
  },
  /**
   * Справочник типов значений сортировки
   */
  "PrivilegePaging.OrderByType": {
    "kind": "enum",
    "text": "Справочник типов значений сортировки",
    "values": {
      /**
       * Значение не указано
       */
      "ORDER_BY_TYPE_UNKNOWN": {
        "i": 0,
        "text": "Значение не указано",
      },
      /**
       * По уникальному ключу: orpon+flat_number+type
       */
      "KEY": {
        "i": 1,
        "text": "По уникальному ключу: orpon+flat_number+type",
      },
    },
  },
}